import { version } from './version'

export const baseEnvironment = {
  version: version,
  statuspageKey: '939xm6l9r7fn',
}
